import { render, staticRenderFns } from "./EstadoFacturas.vue?vue&type=template&id=283d9683&"
import script from "./EstadoFacturas.vue?vue&type=script&lang=js&"
export * from "./EstadoFacturas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports